/**
 * Inlines <style> block CSS rules into matching elements as inline styles.
 *
 * TinyMCE strips <style> tags on setContent, so this converts class/tag-based
 * styles to inline style attributes before insertion.
 *
 * @param {string} html - HTML string that may contain <style> blocks
 * @returns {string} HTML with CSS rules inlined into elements
 */
const inlineStyles = (html) => {
  const styleRegex = /<style[^>]*>([\s\S]*?)<\/style>/gi;
  const styleBlocks = [...html.matchAll(styleRegex)];

  if (styleBlocks.length === 0) {
    return html;
  }

  const container = document.createElement("div");
  container.innerHTML = html;

  for (const block of styleBlocks) {
    const cssText = block[1];
    const ruleRegex = /([^{}]+)\{([^}]+)\}/g;

    for (const rule of cssText.matchAll(ruleRegex)) {
      const selector = rule[1].trim();
      const styles = rule[2].trim();

      try {
        // "body" selector won't match inside a <div> container
        // (browser strips <html>/<body> when parsed as innerHTML).
        // Apply body-level styles to all direct children instead.
        const elements =
          selector === "body"
            ? container.children
            : container.querySelectorAll(selector);

        for (const el of elements) {
          const existing = el.getAttribute("style") || "";
          const merged = existing ? `${existing}; ${styles}` : styles;
          el.setAttribute("style", merged);
        }
      } catch {
        // Skip invalid selectors (e.g. @media, @keyframes)
      }
    }
  }

  // Remove <style> blocks from output
  for (const styleEl of container.querySelectorAll("style")) {
    styleEl.remove();
  }

  return container.innerHTML;
};

export default inlineStyles;
